module.exports = __webpack_public_path__ + "media/vdo-banner.8f2f8855.mp4";